"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _withMapping = _interopRequireDefault(require("../../../Context/withMapping"));

var _WysiwygField = _interopRequireDefault(require("../../WysiwygField"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SearchField = function SearchField(props) {
  var title = props.title,
      required = props.required,
      description = props.description,
      placeholder = props.placeholder,
      fieldName = props.fieldName,
      validation = props.validation,
      touched = props.touched,
      error = props.error,
      type = props.type,
      value = props.value,
      className = props.className,
      wrapperClassName = props.wrapperClassName,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('SearchField', wrapperClassName)
  }, title && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: fieldName
  }, title, " ", !required && /*#__PURE__*/_react.default.createElement("div", {
    className: "WebformComponent--optional"
  }, "- optioneel")), /*#__PURE__*/_react.default.createElement(_formik.Field, {
    className: (0, _classnames.default)(className, {
      'error': error && touched
    }),
    name: fieldName,
    type: type || 'text',
    value: value,
    placeholder: placeholder,
    validate: validation,
    disabled: disabled
  }), description && /*#__PURE__*/_react.default.createElement(_WysiwygField.default, {
    property: "schema:text",
    html: description,
    className: "SearchField__description WebformComponent--description"
  }), error && touched ? /*#__PURE__*/_react.default.createElement("div", {
    className: "SearchField__error WebformComponent--error"
  }, error) : null);
};

var _default = (0, _withMapping.default)(SearchField);

exports.default = _default;